import React from "react";
import "./Footer.css";
import { Link, NavLink } from "react-router-dom";

function Footer() {
  return (
    <section className="Footer">
      <div className="footer-container">
        <NavLink
          to="/home"
          className={({ isActive }) =>
            isActive ? "footer_item active" : "footer_item"
          }
        >
          <img
            className="footer_item_img"
            alt="home"
            src="/assets/images/header/home.png"
          />
        </NavLink>

        <NavLink
          to="/activity"
          className={({ isActive }) =>
            isActive ? "footer_item active" : "footer_item"
          }
        >
          <img
            className="footer_item_img"
            alt="activity"
            src="/assets/images/header/activity.png"
          />
        </NavLink>

        {/* Center GO Button */}
        <Link to={"/invite-wheel"}>
          <div className="footer_center">
            <img
              className="footer_go_item_img"
              alt="go"
              src="/assets/images/header/spin.png"
            />
            <h3>Get ₹500</h3>
          </div>
        </Link>

        <NavLink
          to="/promotion"
          className={({ isActive }) =>
            isActive ? "footer_item active" : "footer_item"
          }
        >
          <img
            className="footer_item_img"
            alt="promotion"
            src="/assets/images/header/promotion.png"
          />
        </NavLink>

        <NavLink
          to="/account"
          className={({ isActive }) =>
            isActive ? "footer_item active" : "footer_item"
          }
        >
          <img
            className="footer_item_img"
            alt="account"
            src="/assets/images/header/account.png"
          />
        </NavLink>
      </div>
    </section>
  );
}

export default Footer;
